import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

/**
 * Submit button for use with form elements
  * @param {object} props - Component props.
  * @param {string} [props.title] - custom text for button, to replace default
  * @param {() => void} [props.onClick] - click handler
  * @param {boolean} [props.disabled] - whether the button is disabled
  * @returns {React.ReactElement}
 */
const SubmitButton = ({
  title,
  onClick,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <button
      className={styles.button}
      type={onClick ? 'button' : 'submit'}
      data-testid="submit-button"
      onClick={onClick}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {title || t('Submit')}
    </button>
  );
};

SubmitButton.propTypes = {
  title: PropTypes.string,
};

export { SubmitButton };
